import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, Validator } from "@angular/forms";
import { AppConstans } from '../appConstants';

/**
 * Kontrola, že je zadán původ UJ.
 * Technicky má význam pouze pro žádost o POP, kde se jedná o materiál z dovozu (zadává uživatel). V postatních případech se položka plní z DB dle UJ.
**/
@Injectable({
  providedIn: 'root'
})
export class PuvodUjValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    let isDovoz = control.parent?.get('pobockaPovereneOsoby')?.value?.kod == AppConstans.popVydalKodMze;
    if (isDovoz && (control.value == void 0 || control.value == '')) {
      return { 'puvodUjError': 'Původ UJ je povinná položka.' };
    }
    return null;
  }
}
